import { render, staticRenderFns } from "./TabItems.vue?vue&type=template&id=fcdc730a&"
import script from "./TabItems.vue?vue&type=script&lang=js&"
export * from "./TabItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports